(function($){
	$.ajax({
		url: theme.ajaxurl,
		method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
		data: {
			action: 'is_user_logged_in'
		},
		success: function(response) {
			if (response.logged_in) {
				$('body').addClass('logged-in');
			}
			else {
				$('body').removeClass('logged-in');
			}
		}
	});
})(jQuery);
